import { endDuty, hydrateDutyRoster, startDuty, type DutyRoster } from "@northstar/dispatch-core";

const KEY = "ns.companion.dutyClock";

export function loadDutyClock(storage?: Pick<Storage, "getItem"> | null): DutyRoster | null {
  try {
    const raw = storage?.getItem(KEY);
    if (!raw) return null;
    return hydrateDutyRoster(JSON.parse(raw) as DutyRoster);
  } catch {
    return null;
  }
}

export function saveDutyClock(roster: DutyRoster, storage?: Pick<Storage, "setItem"> | null): void {
  storage?.setItem(KEY, JSON.stringify(roster));
}

export function clockCrew(
  roster: DutyRoster | null | undefined,
  crew: { id: string; name: string },
  action: "in" | "out",
  now = new Date(),
): DutyRoster {
  const base = hydrateDutyRoster(roster ?? undefined);
  return action === "in" ? startDuty(base, { crewId: crew.id, crewName: crew.name, now }) : endDuty(base, { crewId: crew.id, now });
}
